import { createSlice } from "@reduxjs/toolkit";

export const FORM_STATES = {
  NOT_STARTED: "Not Started",
  IN_PROGRESS: "In Progress",
  SUCCESS: "Success",
  ERROR: "Error",
};

export const initialState = {
  formState: FORM_STATES.NOT_STARTED,
  storeInfo: null,
  orderUnitsInfo: {
    orderUnits: [{ orderUnit: null, orderUnitCount: null }],
    hasFreeProducts: false,
    freeProducts: [],
  },
};

export const orderCreationSlice = createSlice({
  name: "orderCreation",
  initialState,
  reducers: {
    resetOrderCreation: state => {
      state.formState = FORM_STATES.NOT_STARTED;
      state.storeInfo = null;
      state.orderUnitsInfo = { ...initialState.orderUnitsInfo };
    },
    startOrderCreation: state => {
      state.formState = FORM_STATES.IN_PROGRESS;
    },
    orderCreationSuccess: state => {
      state.formState = FORM_STATES.SUCCESS;
    },
    orderCreationError: state => {
      state.formState = FORM_STATES.ERROR;
    },
    updateStoreInfo: (state, action) => {
      state.storeInfo = action.payload;
    },
    updateOrderUnitsInfo: (state, action) => {
      // https://redux-toolkit.js.org/usage/immer-reducers#updating-nested-data
      state.orderUnitsInfo.orderUnits = [...action.payload.orderUnits];
      state.orderUnitsInfo.hasFreeProducts = action.payload.hasFreeProducts;
      state.orderUnitsInfo.freeProducts = [...action.payload.freeProducts];
    },
  },
});
